/**
 * Avatar Component
 * Displays user profile pictures with size variants
 * Sizes: 'sm' (20px), 'md' (32px), 'lg' (48px)
 * Memoized for performance in lists.
 */

import React from 'react';
import styles from './Avatar.module.css';

interface AvatarProps {
  src?: string;
  alt?: string;
  size?: 'sm' | 'md' | 'lg';
  initials?: string;
  className?: string;
}

const AvatarComponent: React.FC<AvatarProps> = ({
  src,
  alt = 'User avatar',
  size = 'md',
  initials,
  className,
}) => {
  const sizeClass = `avatar--${size}`;
  const combinedClassName = [
    'avatar',
    sizeClass,
    !src && 'avatar--placeholder',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        className={combinedClassName}
      />
    );
  }

  return (
    <div className={combinedClassName} title={alt}>
      {initials && <span className={styles.initials}>{initials}</span>}
    </div>
  );
};

export const Avatar = React.memo(AvatarComponent);
